import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: { [key: string]: any } = {
  configs: [],
  info: {}
};

const verification = createSlice({
  name: 'verification',
  initialState,
  reducers: {
    updateVerificationConfigs(state, action: PayloadAction<object[]>) {
      return { ...state, configs: action.payload };
    },
    updateVerificationInfo(state, action: PayloadAction<object>) {
      return { ...state, info: action.payload };
    }
  }
});

const { actions, reducer } = verification;
export const { updateVerificationConfigs, updateVerificationInfo } = actions;
export default reducer;
